import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils";

const iconBadgeVariants = cva(
  "inline-flex shrink-0 items-center justify-center rounded-lg [&_svg]:pointer-events-none [&_svg]:shrink-0",
  {
    variants: {
      tone: {
        indigo: "bg-indigo-500/10 text-indigo-600 dark:text-indigo-400",
        cyan: "bg-cyan-500/10 text-cyan-600 dark:text-cyan-400",
        emerald: "bg-emerald-500/10 text-emerald-600 dark:text-emerald-400",
        amber: "bg-amber-500/10 text-amber-600 dark:text-amber-400",
        rose: "bg-rose-500/10 text-rose-600 dark:text-rose-400",
        slate: "bg-slate-500/10 text-slate-600 dark:text-slate-400",
      },
      size: {
        sm: "size-8 [&_svg:not([class*='size-'])]:size-4",
        md: "size-10 [&_svg:not([class*='size-'])]:size-5",
        lg: "size-12 [&_svg:not([class*='size-'])]:size-6",
      },
    },
    defaultVariants: {
      tone: "slate",
      size: "md",
    },
  },
);

/**
 * Soft tinted icon tile for empty states, metric cards, and feature accents.
 * @param {object} props
 * @param {import("lucide-react").LucideIcon} props.icon
 * @param {"indigo"|"cyan"|"emerald"|"amber"|"rose"|"slate"} [props.tone]
 * @param {"sm"|"md"|"lg"} [props.size]
 */
export function IconBadge({ icon: Icon, tone = "slate", size = "md", className, ...props }) {
  if (!Icon) return null;

  return (
    <div
      data-slot="icon-badge"
      className={cn(iconBadgeVariants({ tone, size }), className)}
      {...props}
    >
      <Icon aria-hidden />
    </div>
  );
}

export { iconBadgeVariants };
